import React, { useEffect, useState } from 'react'

import { FormControl, InputLabel, Select, TableContainer } from '@mui/material'
import { listFromCodes } from '../../../Functions/ListItemGenerator'
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useHoldingContext } from '../../../Contexts/CurrentHolding'
import { useWeaningReportCols } from './WeaningReportCols'
import { useGetWeaningReport } from '../../../APIs/Hooks/ReportServiceHooks'
import PageSection from '../../../Constants&Theme/PageSection'
import { appBar } from '../../../garvan-react/Constants/StyleConstants'
import { reportDGProps } from '../ReportProps'
import { delay } from '../../../Functions/DelayFn'

function WeaningReport() {
  const { currentHolding } = useHoldingContext()
  const { loginConfig, loadingConfig } = useUserContext()
  const [holdingID, setHoldingID] = useState(currentHolding.value)
  const reportQuery = useGetWeaningReport(holdingID)
  const holdings = listFromCodes(
    loginConfig,
    'KV-Holdings',
    loadingConfig,
    currentHolding.value,
  )
  const columns = useWeaningReportCols()

  const apiRef = useGridApiRef()
  useEffect(() => {
    ;(async () => {
      // delay to await DOM render of values
      delay(500).then(() => {
        if (apiRef?.current?.autosizeColumns) {
          apiRef.current.autosizeColumns({
            includeOutliers: false,
            includeHeaders: true,
          })
        }
      })
    })()
  }, [apiRef, reportQuery.data])

  return (
    <PageSection title={'Weaning Report'}>
      <FormControl
        fullWidth
        sx={{ mb: 2 }}
      >
        <InputLabel>Select Holding</InputLabel>
        <Select
          inputProps={{ 'aria-label': 'SelectHolding' }}
          label="Select Holding"
          value={holdingID}
          onChange={(e) => setHoldingID(e.target.value as number)}
        >
          {holdings}
        </Select>
      </FormControl>
      <TableContainer
        sx={{ height: `calc(100vh - ${appBar}px - 300px)`, width: 1 }}
      >
        <DataGridPro
          {...reportDGProps}
          disableVirtualization //virtualized columns aren't autosized
          apiRef={apiRef}
          rows={reportQuery.data ?? []}
          columns={columns}
          getRowId={(row) => `${row.ShortLineName}${row.DOB}${row.bpid}`}
          loading={reportQuery.isFetching}
        />
      </TableContainer>
    </PageSection>
  )
}

export default WeaningReport
